module.exports = __webpack_public_path__ + "static/img/icon-marker.8eaa60c.png";